
// 获取url上的参数
export const getUrlParam = (name) => {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");　　　　　　//构造一个含有目标参数的正则表达式对象
  let r = window.location.search.substr(1).match(reg);　　　　　　　 //匹配目标参数
  if (r != null) return decodeURIComponent(r[2]); return null;　　　//返回参数值　
}

// 节流
export function throttle(fn, delay = 1500) {
  // console.log(222)
    let flag = true
    return function () {
      if (!flag) return
      flag = false
      const args = arguments
		  fn.apply(this, args)
      setTimeout(() => {
        flag = true
      }, delay)
    }
}

// 类型判断
export function getType(value) {
	return Object.prototype.toString.call(value).slice(8, -1)
}

export function setData(key, val) {
  let addVal = null
  switch(getType(val)) {
    case 'Object':
      addVal = JSON.stringify(val)
      break;
    case 'Array':
      addVal = JSON.stringify(val)
      break;
    default:
      addVal = val
  }
  localStorage.setItem(key, addVal)
}

export function getData(key) {
  if (!key) return
  const data = localStorage.getItem(key)
  if (typeof data === 'string') {
    try {
      const obj = JSON.parse(data);
      if (typeof obj === 'object' && obj) {
        return obj;
      } else {
        return data;
      }
    } catch (e) {
       return data;
    }
  }
}

export function delData(key) {
  localStorage.removeItem(key)
}



// WEBPACK FOOTER //
// ./src/util/util.js